import { useContext } from 'react';

import { MessageContext } from '../context/FileMessageContext';

export const useMessageContext = () => {
  const context = useContext(MessageContext);

  if (!context) throw new Error('MessageContext must be used within a provider');

  return context;
};
